import React, { useState } from 'react'
import { Box } from '@mui/material'
import { SignIn } from '../../components/auth/SignIn'
import { SignUp } from '../../components/auth/SignUp'

export const AuthPage: React.FC = () => {
  const [isSignUp, setIsSignUp] = useState(false)

  const handleToggleMode = () => {
    setIsSignUp(!isSignUp)
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#121212', // Dark background instead of gradient
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 1,
          opacity: 0.3,
        }}
        onError={(e) => {
          console.error('Video error:', e)
          // Try to reload the video after an error
          const video = e.target as HTMLVideoElement
          setTimeout(() => {
            video.load()
            video.play().catch(console.error)
          }, 1000)
        }}
        onLoadStart={() => console.log('Video loading started')}
        onCanPlay={(e) => {
          console.log('Video can play')
          const video = e.target as HTMLVideoElement
          video.play().catch(console.error)
        }}
        onStalled={(e) => {
          console.log('Video stalled, attempting to restart')
          const video = e.target as HTMLVideoElement
          video.currentTime = 0
          video.play().catch(console.error)
        }}
        onWaiting={() => {
          console.log('Video waiting for data')
        }}
      >
        <source src="/background-video-2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Auth Form Content */}
      <Box sx={{ position: 'relative', zIndex: 10, width: '100%' }}>
        {isSignUp ? (
          <SignUp onToggleMode={handleToggleMode} />
        ) : (
          <SignIn onToggleMode={handleToggleMode} />
        )}
      </Box>
    </Box>
  )
}
